export default "__VITE_ASSET__DWjHPokR__";